import { Component, Event, EventEmitter, Prop, h } from '@stencil/core';

@Component({
  tag: 'biel-search-header',
  styleUrl: 'biel-search-header.css',
  shadow: true,
})
export class BielSearchHeader {
  @Prop() placeholderText: string = 'Search or ask AI...';
  @Prop() hideFilters: boolean = true;
  @Prop() filters: { title: string }[] = [];
  @Prop() bielId: string;
  @Prop() searchQuery: string;
  @Prop() hideExpandButton: boolean = false;
  @Prop() isFullscreen: boolean = false;
  @Prop() expandButtonText: string = 'Expand';
  @Prop() collapseButtonText: string = 'Collapse';
  @Prop() closeButtonText: string = 'Close';
  @Prop() hideTooltips: boolean = false;

  @Event() closeSearchClicked: EventEmitter<{ bielId: string }>;
  @Event() expandSearchClicked: EventEmitter<{ bielId: string }>;

  handleCloseClick() {
    this.closeSearchClicked.emit({ bielId: this.bielId });
  }

  handleExpandClick() {
    this.expandSearchClicked.emit({ bielId: this.bielId });
  }

  render() {
    return (
      <div class="biel-search-header" part="container">
        <div class="biel-search-header-container" part="input-container">
          <biel-search-input
            placeholderText={this.placeholderText}
            exportparts="container: biel-search-input-container, input: biel-search-input-input"
          ></biel-search-input>
          <div class="header-actions">
            {!this.hideExpandButton && (
              <button
                type="button"
                class="action-button action-button--expand"
                part="expand-button"
                aria-label={this.isFullscreen ? this.collapseButtonText : this.expandButtonText}
                onClick={() => this.handleExpandClick()}
              >
                {this.isFullscreen ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-minimize-2"
                  >
                    <polyline points="4 14 10 14 10 20" />
                    <polyline points="20 10 14 10 14 4" />
                    <line x1="14" x2="21" y1="10" y2="3" />
                    <line x1="3" x2="10" y1="21" y2="14" />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-maximize-2"
                  >
                    <polyline points="15 3 21 3 21 9" />
                    <polyline points="9 21 3 21 3 15" />
                    <line x1="21" x2="14" y1="3" y2="10" />
                    <line x1="3" x2="10" y1="21" y2="14" />
                  </svg>
                )}
                {!this.hideTooltips && (
                  <span class="action-button__tooltip">
                    {this.isFullscreen ? this.collapseButtonText : this.expandButtonText}
                  </span>
                )}
              </button>
            )}
            <button
              type="button"
              class="action-button"
              part="close-button"
              aria-label={this.closeButtonText}
              onClick={() => this.handleCloseClick()}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="2 2 20 20"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-x"
              >
                <path d="M18 6 6 18" />
                <path d="m6 6 12 12" />
              </svg>
              {!this.hideTooltips && (
                <span class="action-button__tooltip">{this.closeButtonText}</span>
              )}
            </button>
          </div>
        </div>
        <div class="biel-search-header__filters-container" part="filters-container">
          {!this.hideFilters && this.filters.length > 0 && this.searchQuery !== '' && (
            <biel-search-filters
              class="biel-search-header__filters"
              filters={this.filters}
              exportparts="container: biel-search-filters-container, filter-button: biel-search-filters-filter-button"
            ></biel-search-filters>
          )}
        </div>
      </div>
    );
  }
}
